export function getDayOfWeek(dateString: string) {
    const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const date = new Date(dateString);
    return days[date.getDay()];
}

// Индекс дня недели в календаре с понедельника: 0 = понедельник, 6 = воскресенье
export function getWeekdayIndex(dateString: string) {
    return (new Date(dateString).getDay() + 6) % 7;
}
